<template>
  <div style="background:#f3f3f3;">
      <div class="wapper overf" >
	<div class="part">
       <img src="../../static/img/banner.jpg" width="100%"  />
	</div>
</div>


<div class="wapper overf">
	<div class="part main-box2" style="background:#fff; padding:50px;">
        
        <div class="tit3"><em><a @click="goHome()">返回首页>></a></em><span>举报单位</span></div>
        <div class="m_t_20 main-box">
          <div style="width:30px; height:100%; float:left; border-right:1px solid #ddd; font-size:24px; color:#333; line-height:24px; padding:100px 29px;"><b>举报人信息</b></div>
          <div class="f-left">
           <div class="main-box2" style="padding:20px;">
               <form action="" method="post" :model="tail" class="bootstrap-frm t-center" style="margin:0 auto;"><!-- 修改 class 名称 对应效果 -->
                  <div class="overf">
                  <label > <span>举报人姓名 :（<font color="#f00">*</font>）</span>
                    <input id="reporterName" type="text" name="reporterName" placeholder=" " v-model="tail.reporterName"   />
                  </label >
                  <label> <span>性别 :</span>
                    <select name="selection" v-model="tail.reporterSex" >
                      <option value="">请选择</option>
                      <option value="1">男</option>
                      <option value="0">女</option>
                    </select>
                  </label>
                
                  <label > <span>所在单位 :（<font color="#f00">*</font>）</span>
                    <input id="reporterUnit" type="text" name="reporterUnit" placeholder=" " v-model="tail.reporterUnit"/>
                  </label >
                  <label> <span>职务 :</span>
                    <select id="reporterDutycode" name="reporterDutycode" class="in2b" v-model="tail.reporterDutycode">
                <option value="">请选择</option>   
                <!-- duty -->
				   <option>书记</option>
<option>副书记</option>
<option>第一书记</option>
<option>第二书记</option>
<option>第三书记</option>
<option>代理书记</option>
<option>候补书记</option>
<option>总书记</option>
<option>委员</option>
<option>第一副主任委员</option>
<option>常务委员</option>
<option>候补委员</option>
<option>主任委员</option>
<option>副主任委员</option>
<option>成员</option>
<option>主任</option>
<option>副主任</option>
<option>代理主任</option>
<option>主任助理</option>
<option>顾问</option>
<option>执行委员</option>
<option>巡视员</option>
<option>副巡视员</option>
<option>调研员</option>
<option>副调研员</option>
<option>督导员</option>
<option>检查员</option>
<option>监察员</option>
<option>纪检员</option>
<option>审计员</option>
<option>组织员</option>
<option>联络员</option>
<option>助理联络员</option>
<option>特派员</option>
<option>副特派员</option>
<option>助理特派员</option>
<option>侦察员</option>
<option>管教员</option>
<option>稽核员</option>
<option>总审计师</option>
<option>副总审计师</option>
<option>首席工程师</option>
<option>总工程师</option>
<option>副总工程师</option>
<option>主任工程师</option>
<option>总农艺师</option>
<option>副总农艺师</option>
<option>委员长</option>
<option>副委员长</option>
<option>秘书长</option>
<option>副秘书长</option>
<option>秘书长助理</option>
<option>秘书</option>
<option>检察长</option>
<option>副检察长</option>
<option>代理检察长</option>
<option>检察长助理</option>
<option>检察员</option>
<option>助理检察员</option>
<option>审判员</option>
<option>助理审判员</option>
<option>庭长</option>
<option>副庭长</option>
<option>书记员</option>
<option>监狱长</option>
<option>副监狱长</option>
<option>监狱长助理</option>
<option>法治员</option>
<option>总畜牧师</option>
<option>副总畜牧师</option>
<option>国家首席兽医师</option>
<option>总兽医师</option>
<option>副总兽医师</option>
<option>总经济师</option>
<option>副总经济师</option>
<option>首席会计师</option>
<option>总会计师</option>
<option>副总会计师</option>
<option>总统计师</option>
<option>副总统计师</option>
<option>总编辑助理</option>
<option>总编辑</option>
<option>副总编辑</option>
<option>主席</option>
<option>副主席</option>
<option>第一副主席</option>
<option>代理主席</option>
<option>主席助理</option>
<option>名誉主席</option>
<option>执行主席</option>
<option>执行副主席</option>
<option>总理</option>
<option>副总理</option>
<option>代理总理</option>
<option>国务委员</option>
<option>部长</option>
<option>副部长</option>
<option>部长助理</option>
<option>审计长</option>
<option>副审计长</option>
<option>署长</option>
<option>副署长</option>
<option>关长</option>
<option>副关长</option>
<option>局长</option>
<option>副局长</option>
<option>局长助理</option>
<option>厅长</option>
<option>副厅长</option>
<option>厅长助理</option>
<option>司长</option>
<option>副司长</option>
<option>处长</option>
<option>副处长</option>
<option>科长</option>
<option>副科长</option>
<option>科员</option>
<option>主任科员</option>
<option>副主任科员</option>
<option>股长</option>
<option>副股长</option>
<option>办事员</option>
<option>总医药师</option>
<option>副总医药师</option>
<option>省长</option>
<option>副省长</option>
<option>代理省长</option>
<option>省长助理</option>
<option>市长</option>
<option>副市长</option>
<option>代理市长</option>
<option>市长助理</option>
<option>州长</option>
<option>副州长</option>
<option>代理州长</option>
<option>州长助理</option>
<option>区长</option>
<option>副区长</option>
<option>代理区长</option>
<option>区长助理</option>
<option>盟长</option>
<option>副盟长</option>
<option>代理盟长</option>
<option>盟长助理</option>
<option>专员</option>
<option>副专员</option>
<option>专员助理</option>
<option>县长</option>
<option>副县长</option>
<option>代理县长</option>
<option>县长助理</option>
<option>旗长</option>
<option>副旗长</option>
<option>代理旗长</option>
<option>旗长助理</option>
<option>镇长</option>
<option>副镇长</option>
<option>代理镇长</option>
<option>乡长</option>
<option>副乡长</option>
<option>代理乡长</option>
<option>大使</option>
<option>代办</option>
<option>公使</option>
<option>公使衔参赞</option>
<option>政务参赞</option>
<option>新闻参赞</option>
<option>经济参赞</option>
<option>科技参赞</option>
<option>商务参赞</option>
<option>文化参赞</option>
<option>教育参赞</option>
<option>警务联络官(警务参赞)</option>
<option>参赞</option>
<option>大使衔总领事</option>
<option>总领事</option>
<option>副总领事</option>
<option>馆长领事</option>
<option>首席领事</option>
<option>领事</option>
<option>副领事</option>
<option>武官</option>
<option>副武官</option>
<option>武官助理</option>
<option>大使衔代表</option>
<option>大使衔副代表</option>
<option>代表</option>
<option>副代表</option>
<option>代表助理</option>
<option>首席代表</option>
<option>首席馆员</option>
<option>一等助理</option>
<option>二等助理</option>
<option>三等助理</option>
<option>一等秘书</option>
<option>二等秘书</option>
<option>三等秘书</option>
<option>随员</option>
<option>职员</option>
<option>雇员</option>
<option>档案秘书</option>
<option>留守组长</option>
<option>留守组员</option>
<option>组长</option>
<option>副组长</option>
<option>行长</option>
<option>副行长</option>
<option>行长助理</option>
<option>台长</option>
<option>副台长</option>
<option>台长助理</option>
<option>理事长</option>
<option>副理事长</option>
<option>理事长助理</option>
<option>理事</option>
<option>首席监事</option>
<option>监事</option>
<option>专职监事</option>
<option>参事</option>
<option>会长</option>
<option>副会长</option>
<option>干事</option>
<option>总干事</option>
<option>副总干事</option>
<option>社长</option>
<option>副社长</option>
<option>社长助理</option>
<option>馆长</option>
<option>副馆长</option>
<option>馆长助理</option>
<option>名誉馆长</option>
<option>所长</option>
<option>副所长</option>
<option>所长助理</option>
<option>名誉所长</option>
<option>院长</option>
<option>副院长</option>
<option>代理院长</option>
<option>院长助理</option>
<option>名誉院长</option>
<option>校长</option>
<option>副校长</option>
<option>校长助理</option>
<option>名誉校长</option>
<option>教务长</option>
<option>副教务长</option>
<option>总务长</option>
<option>副总务长</option>
<option>教育长</option>
<option>副教育长</option>
<option>船长</option>
<option>副船长</option>
<option>总船长</option>
<option>副总船长</option>
<option>护士长</option>
<option>园长</option>
<option>副园长</option>
<option>独立董事</option>
<option>职工代表董事</option>
<option>执行董事</option>
<option>总裁</option>
<option>副总裁</option>
<option>总裁助理</option>
<option>董事长</option>
<option>副董事长</option>
<option>名誉董事长</option>
<option>董事</option>
<option>常务董事</option>
<option>轮机长</option>
<option>副轮机长</option>
<option>总轮机长</option>
<option>副总轮机长</option>
<option>总经理</option>
<option>副总经理</option>
<option>总监</option>
<option>经理</option>
<option>副经理</option>
<option>经理助理</option>
<option>分局长</option>
<option>副分局长</option>
<option>站长</option>
<option>副站长</option>
<option>厂长</option>
<option>副厂长</option>
<option>代理厂长</option>
<option>厂长助理</option>
<option>场长</option>
<option>副场长</option>
<option>矿长</option>
<option>副矿长</option>
<option>分场长</option>
<option>副分场长</option>
<option>总站长</option>
<option>副总站长</option>
<option>指挥</option>
<option>副指挥</option>
<option>指挥助理</option>
<option>总指挥</option>
<option>副总指挥</option>
<option>调度长</option>
<option>副调度长</option>
<option>总调度长</option>
<option>副总调度长</option>
<option>调度</option>
<option>大副</option>
<option>二副</option>
<option>三副</option>
<option>总规划师</option>
<option>副总规划师</option>
<option>总设计师</option>
<option>副总设计师</option>
<option>总工艺师</option>
<option>副总工艺师</option>
<option>总地质师</option>
<option>副总地质师</option>
<option>总农经师</option>
<option>副总农经师</option>
<option>总飞行师</option>
<option>副总飞行师</option>
<option>督学</option>
<option>副督学</option>
<option>总督学</option>
<option>副总督学</option>
<option>总稽核</option>
<option>副总稽核</option>
<option>总教练</option>
<option>副总教练</option>
<option>首席律师</option>
<option>首席精算师</option>
<option>首席稽查</option>
<option>总督察</option>
<option>副总督察</option>
<option>督察长</option>
<option>副督察长</option>
<option>参谋长</option>
<option>副参谋长</option>
<option>参谋长助理</option>
<option>总参谋长助理</option>
<option>总参谋长</option>
<option>副总参谋长</option>
<option>参谋</option>
<option>司令员</option>
<option>副司令员</option>
<option>军长</option>
<option>副军长</option>
<option>师长</option>
<option>副师长</option>
<option>旅长</option>
<option>副旅长</option>
<option>团长</option>
<option>副团长</option>
<option>营长</option>
<option>副营长</option>
<option>连长</option>
<option>副连长</option>
<option>排长</option>
<option>副排长</option>
<option>班长</option>
<option>副班长</option>
<option>舰长</option>
<option>副舰长</option>
<option>舰务长</option>
<option>副舰务长</option>
<option>航海长</option>
<option>副航海长</option>
<option>艇长</option>
<option>副艇长</option>
<option>机长</option>
<option>副机长</option>
<option>领航长</option>
<option>副领航长</option>
<option>大队长</option>
<option>副大队长</option>
<option>队长</option>
<option>副队长</option>
<option>总队长</option>
<option>副总队长</option>
<option>中队长</option>
<option>副中队长</option>
<option>支队长</option>
<option>副支队长</option>
<option>分队长</option>
<option>副分队长</option>
<option>区队长</option>
<option>副区队长</option>
<option>哨长</option>
<option>副哨长</option>
<option>政治委员</option>
<option>副政治委员</option>
<option>第一政治委员</option>
<option>政治教导员</option>
<option>副政治教导员</option>
<option>协理员</option>
<option>副协理员</option>
<option>政治指导员</option>
<option>副政治指导员</option>
<option>助理员</option>
<option>军事代表</option>
<option>总军事代表</option>
<option>副总军事代表</option>
<option>教官</option>
<option>司务长</option>
<option>专职干部</option>
<option>常委</option>
<option>市委书记</option>
<option>市委副书记</option>
<option>党委书记</option>
<option>党委副书记</option>
<option>党委常委</option>
<option>党委委员</option>
<option>机关党委书记</option>
<option>机关党委副书记</option>
<option>机关党委常务副书记</option>
<option>党组书记</option>
<option>党组副书记</option>
<option>党组成员</option>
<option>机关纪委书记</option>
<option>机关纪委副书记</option>
<option>机关党组书记</option>
<option>机关党组副书记</option>
<option>机关党组成员</option>
<option>书记处书记</option>
<option>书记处副书记</option>
<option>书记处第一书记</option>
<option>书记处第二书记</option>
<option>书记处第三书记</option>
<option>书记处候补书记</option>
<option>主席团主席</option>
<option>主席团副主席</option>
<option>纪检组组长</option>
<option>纪检组副组长</option>
<option>党组纪检组组长</option>
<option>党组纪检组副组长</option>
<option>中央纪委驻XXX纪检组组长</option>
<option>中央纪委驻XXX纪检组副组长</option>
<option>中央纪委驻金融系统纪检组组长</option>
<option>监察部驻XXX监察局局长</option>
<option>监察部驻XXX监察局副局长</option>
<option>监事会主席</option>
<option>监事会副主席</option>
<option>监事会主任</option>
<option>监事会副主任</option>
<option>理事会理事长</option>
<option>理事会副理事长</option>
<option>执行理事会理事长</option>
<option>执行理事会副理事长</option>
<option>理事会主任</option>
<option>理事会副主任</option>
<option>办公室主任</option>
<option>办公室副主任</option>
<option>审判委员会委员</option>
<option>检察委员会委员</option>
<option>校委会委员</option>
<option>室务委员会委员</option>
<option>编辑委员会委员</option>
<option>海外版总编辑</option>
<option>中央人民广播电台台长</option>
<option>中国国际广播电台台长</option>
<option>中央电视台台长</option>
<option>后勤部部长</option>
<option>后勤部政治委员</option>
<option>政治部主任</option>
<option>政治部副主任</option>
<option>纪委书记</option>
<option>纪委副书记</option>
<option>纪工委书记</option>
<option>纪工委副书记</option>
<option>人大主任</option>
<option>政协主席</option>
<option>监察专员</option>
<option>副监察专员</option>
<option>专员助理</option>
<option>国家版权局局长</option>
<option>国家版权局副局长</option>
<option>外交部驻香港特别行政区特派员公署特派员</option>
<option>外交部驻香港特别行政区特派员公署副特派员</option>
<option>外交部驻澳门特别行政区特派员公署特派员</option>
<option>外交部驻澳门特别行政区特派员公署副特派员</option>
<option>首席谈判代表</option>
<option>谈判副代表</option>
<option>谈判代表助理</option>
<option>国家航天局局长</option>
<option>国家原子能机构主任</option>
<option>国家核安全局局长</option>
<option>国家认证认可监督管理委员会主任</option>
<option>国家标准化管理委员会主任</option>
<option>国家安全生产应急救援指挥中心主任</option>
<option>国务院学科组召集人</option>
<option>特命全权裁军事务大使</option>
<option>其他</option>
				
		</select>
                  </label>
                
                    <label > <span>身份证号 :（<font color="#f00">*</font>）</span>
                    <input id="reporterIdNumber" type="text" name="reporterIdNumber" maxlength="18" placeholder=" " v-model="tail.reporterIdNumber"/>
                  </label >
                  <label> <span>邮政编码 :</span>
                    <input id="reporterPostCode" type="text" name="reporterPostCode" placeholder=" " v-model="tail.reporterPostCode"/>
                  </label>
                
                  <label > <span>所在地区 :</span>
                    <input id="reporterArea" type="text" name="reporterArea" placeholder=" " v-model="tail.reporterArea"/>
                  </label >
                  <label> <span>联系电话:（<font color="#f00">*</font>）</span>
                    <input id="reporterPhoneNum" type="text" name="reporterPhoneNum" placeholder=" " v-model="tail.reporterPhoneNum"/>
                  </label>
                  <label style="width:100%;"> <span>联系地址 :</span>
                    <input type="text"  placeholder=" " style="width:690px;" v-model="tail.address"/>
                  </label >
                  </div>  
                </form>
          </div>
        </div>        
	</div>
</div>
</div>


<div class="wapper overf">
	<div class="part main-box2" style="background:#fff; padding:0 50px 50px 50px;">
        
        <div class="m_t_20 main-box">
          <div style="width:40px; height:100%; float:left; border-right:1px solid #ddd; font-size:24px; color:#333; line-height:24px; padding:190px 24px; text-align:center;"><b>被举报单位信息</b><br /><font class="f12 cRed">(必填)</font></div>
          <div class="f-left">
           <div class="main-box2" style="padding:20px;">
                <form action="" method="post" class="bootstrap-frm2 t-center" style="margin:0 auto;"><!-- 修改 class 名称 对应效果 -->
                  <div class="overf">
                  <label style="width:100%;"> <span>单位名称 :（<font color="#f00">*</font>）</span>
                    <input id="byReporterUnit" type="text" name="byReporterUnit" placeholder=" " style="width:690px;" v-model="tail.byReporterUnit"/>
                  </label >
                  
                  <label style="width:100%;"> <span>单位级别 :</span>
                    <select id="byReporterUnitLevel" name="byReporterUnitLevel" class="in2" style="width:690px;" v-model="tail.byReporterUnitLevel">
            <option value="">请选择</option>
               
                <option >省、部级</option>   
               
                <option >副省、副部级</option>   
               
                <option >地、厅、司、局级</option>   
               
                <option >副地、副厅、副司、副局级</option>   
               
                <option >县、处级</option>   
               
                <option >副县、副处级</option>   
               
                <option >乡、科级</option>   
               
                <option >副乡、副科级</option>   
               
                <option >其他</option>   
            
         </select>
                   </label>
                   <label style="width:100%;"> <span>所在地区 :（<font color="#f00">*</font>）</span>
				   
                     <select id="cityArea" name="cityArea" class="in2" style="width:345px;" v-model="cityArea" >
						<option
						v-for="item in level1"
						:key="item.areaCode"
						:label="item.areaCity"
						:value="item.areaCode">
						</option>
                        <!-- <option value="">请选择</option> -->
                     </select>
                     <select id="countyArea" name="countyArea" class="in2"  v-model="countyArea" style="width:345px;">
						<option
						v-for="item in level2"
						:key="item.areaCode"
						:label="item.areaCity"
						:value="item.areaCode">
						</option>
                     </select>
                    <input id="byReporterAddress" type="text" name="byReporterAddress" placeholder="详细地址" style="width:690px; margin-left:160px;" v-model="tail.byReporterAddress"/>
                  </label>
                  <label style="width:100%;"> <span>问题类型 :（<font color="#f00">*</font>）</span>
                    <select name="" class="in2" id="wenti1" onchange="slectWenti()" style="width:690px;height:34px;" v-model="tail.problemType">
                        <option >请选择</option>
                        <option >选人用人问题</option>
                        <option >不担当不作为问题</option>
                        <option >其他问题</option>
                    </select>
                  </label>
                  <label style="width:100%;"> <span>主要问题 :（<font color="#f00">*</font>）</span>
                    <textarea id="mainProblem" name="mainProblem" style="width:690px; height:232px" onkeypress="if (this.value.length>=10000){alert(&quot;输入内容不能超过10000个字&quot;);event.returnValue=false;}" maxlength="10000" v-model="tail.mainProblem"></textarea>
                    
                  </label>
				  <label style="width:100%;">
					   <span>验证码 :（<font color="#f00">*</font>）</span>
					    <input
						type="text"
						style="width:200px"
						name="code"
						v-model="tail.code"
						autoComplete="on"
						placeholder="请输入右边的验证码"
						/><img
						@click="handleGetLoginCode"
						:src="captcha+'/captcha/add?uuid='+tail.uuid"
						alt=""
						>

				  </label>
                  <label style="width:100%; font-size:14px;">  注：标有<font color="#f00">*</font>的项目为必填项，不填写将不能提交。      </label>
                  </div>  
                </form>
          </div>
        </div>  
	</div>
                <div class="m_t_30" style=" text-align:center;">
                 <a href="javascript:void(0);" @click="save()" class="button button-caution button-rounded button-large " style="background:#a00; margin-left:50px;">我要提交</a>
                 <a href="javascript:void(0);" @click="reload()" class="button button-caution button-rounded button-large " style="background:#a00; margin-left:50px;">重 写</a>
                </div>

</div>
</div>



<div class="clear overf m_t_40"></div>
<!---- foot ---->
<div class="wapper overf p_b_10" style="background:#AD0C1D;" >
  <div class="part p_t_20 h26 cWhite f14 overf" >
	  <div class="t-center">	
              <p class=" p_l_10 ">
Copyright© 2010.中共湖南省委组织部举报中心 All Rights Reserved 
			  </p>
			  <p class=" p_l_10 ">
    备案号：<a href="http://beian.miit.gov.cn/" target="_blank">湘ICP备17016663号-2</a>
                </p>
     </div>
</div>
</div>

  </div>
</template>

<script>
import request from '@/utils/request'

export default {
  data () {
    return {
       captcha:process.env.BASE_API,
	  areaCode: '',
	  secAreaCode: '',
	  level1:[],
	  level2:[],
	  cityArea:'',
	  countyArea:'',
	  tail: {
    reporterName: "",
    reporterSex:"",
    reporterUnit: "" ,
    reporterDutycode: "" ,
    reporterIdNumber: "" ,
    reporterPostCode: "" ,
    reporterArea: "" ,
		reporterPhoneNum: "",
		address: "",

  
    byReporterUnit: "" ,
    byReporterUnitLevel: "" ,
		byReporterAreaCode: "",
		byReporterAddress: "",
		problemType: "",
		mainProblem: "",
		type: 2,
		code: '',
		uuid :'',

      },
    }
  },
  mounted(){
	this.areaCode=this.$route.params.areaCode
	this.init()
	if(!this.$route.params.areaCode){
		this.cityArea='1018'
	}
	else if(this.$route.params.areaCode.length===7){
		this.cityArea=this.$route.params.areaCode||'1018'
	}else if (this.$route.params.areaCode.length===10){
		this.countyArea=this.$route.params.areaCode||'1018'
	}else{
		this.cityArea=this.$route.params.areaCode||'1018'
	}
  },
  methods:{
	  init(){
       if(this.areaCode){
		  if(this.areaCode.length===10){
			  request({
				url: '/area/'+this.areaCode,
				method: 'get'
			}).then(res => {
				this.cityArea =  res.data.areaParent;
				});
			request({
				url: '/area/list-by-parent/1018',
				method: 'get'
			}).then(res => {
				this.level1 = res.data.unshift({areaCode:"1018", areaCity:"湖南省"}) && res.data;
				});
		  }else{
			request({
				url: '/area/list-by-parent/1018',
				method: 'get'
			}).then(res => {
				this.level1 = res.data.unshift({areaCode:"1018", areaCity:"湖南省"}) && res.data;
				});
		  }
		  }else{
			request({
				url: '/area/list-by-parent/1018',
				method: 'get'
			}).then(res => {
				this.level1 = res.data.unshift({areaCode:"1018", areaCity:"湖南省"}) && res.data;
				});
		  }
	  },
      goHome(){
          this.$router.push({name:'index'})
	  },
	  save(){
		//   this.$refs['tail'].validate((valid) => {
        //   if (valid) {
        //     this.updateParams.attachments = this.imageList
        //     this.updateParams.content     = this.tail.content
        //     this.updateParams.id          = this.willId
		//     this.updateParams.title       = this.tail.title
		if(this.valid()){
        if(this.countyArea!=''){
          this.tail.byReporterAreaCode=this.countyArea;
        }else{
          this.tail.byReporterAreaCode=this.cityArea;
        }
        request({
              url: '/org-report/add',
			  method: 'post',
              data: this.tail
            }).then((res)=>{
				console.log(res)
				this.$router.push({name:'cxm',params:{queryCode:res.data.queryCode}})
            }).catch(err => {
               this.handleGetLoginCode()
                alert(err.response.data.error)
             });
		}else{
			return false;
		}
        //   } else {
        //     return false;
        //   }
        // });

	  },
	  valid(){
     if(this.tail.reporterName.trim()===''){
			alert("请输入举报人姓名")
			return false;
		}
		if(this.tail.reporterName.length >20){
			alert("举报人姓名大于20个字符")
			return false;
		}
		if(this.tail.reporterUnit.trim()===''){
			alert("请输入举报人所在单位")
			return false;
		}
		if(this.tail.reporterUnit.length >200){
			alert("举报人所在单位大于200个字符")
			return false;
		}
		if(this.tail.reporterIdNumber.trim()===''){
			alert("请输入举报人身份证号码")
			return false;
		}
		if(!this.checkIdCard(this.tail.reporterIdNumber)){
            alert("身份证号格式填写有误")
			return false;
        }
		if(this.tail.reporterIdNumber.length >40){
			alert("举报人身份证号码大于40个字符")
			return false;
    }
    if(this.tail.reporterArea.length >200){
			alert("举报人所在地区大于200个字符")
			return false;
		}
		if(this.tail.reporterPhoneNum.trim()===''){
			alert("请输入举报人联系电话")
			return false;
		}
		if(this.tail.reporterPhoneNum.length >40){
			alert("举报人联系电话大于40个字符")
			return false;
		}
		if(this.tail.byReporterUnit.trim()===''){
			alert("请输入举报单位")
			return false;
		}
		if(this.tail.byReporterUnitLevel.trim()===''){
			alert("请输入被举报单位级别")
			return false;
		}
		if(this.tail.byReporterAddress.trim()===''){
			alert("请输入被举报单位详细地址")
			return false;
    }
    if(this.tail.byReporterAddress.length >200){
			alert("被举报单位详细地址大于200个字符")
			return false;
		}
		if(this.tail.problemType.trim()===''){
			alert("请输入被举报单位举报类型")
			return false;
		}
		if(this.tail.mainProblem.trim()===''){
			alert("请输入被举报单位主要问题")
			return false;
    }
    if(this.tail.mainProblem.length >10000){
			alert("被举报单位主要问题大于10000个字符")
			return false;
		}
		if(this.tail.code.trim()===''){
			alert("请输入验证码")
			return false;
		}
		return true
	  },
	  checkIdCard(idcard) {
			const regIdCard = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
			if (!regIdCard.test(idcard)) {
				return false;
			} else {
				return true;
			}
		},
	  //生成验证码uuid
      handleGetLoginCode() {
          this.tail.uuid = Date.now().toString()
      },
      reload(){
		  window.location.reload()
	  },
  },  
  created(){
     this.handleGetLoginCode() //更新uuid生产验证码
  },
  watch:{
		cityArea(val){
			if(val.length>4){
			  request({
			url: '/area/list-by-parent/'+this.cityArea,
			method: 'get'
 			}).then(res => {
			//this.level2 = res.data
				this.level2 = res.data.filter( (item,i) =>{
				return item.areaCity!='昭山'&&item.areaCity!='经开区'&&item.areaCity!='南湖风景区'&&item.areaCity!='屈原管理区'&&item.areaCity!='洪江区'
			} );
			this.level2.map((it,j)=>{ 
				if(it.areaCity=='宁乡县'){
				it.areaCity='宁乡市'
				}
				if(it.areaCity=='株洲县'){
				it.areaCity='渌口区'
				}  if(it.areaCity=='邵东县'){
				it.areaCity='邵东市'
				}
			})
            });
		  }else{
			  this.level2=''
		  }

		}
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/* 简约*/
.bootstrap-frm {  max-width: 900px;}
.bootstrap-frm h1 { height:60px; line-height:60px; font-size:18px; border:none; padding:0; margin:0; color:#333;}
.bootstrap-frm label { width:48%; display: block; margin: 0px 0px 5px; padding-right:1.5%; float:left; }
.bootstrap-frm label span { float: left; width:150px; text-align: right; padding-right: 10px; margin-top: 10px;  font-weight: normal; font-size:16px; color:#333; }
.bootstrap-frm input[type="text"], 
.bootstrap-frm input[type="email"], 
.bootstrap-frm textarea, 
.bootstrap-frm select {width:240px; float:left; border: 1px solid #CCC; color: #888; height: 20px; line-height: 15px; margin-bottom: 16px; margin-right: 6px; margin-top: 2px; outline: 0 none; padding: 5px 0px 5px 5px;  border-radius: 4px; -webkit-border-radius: 4px; -moz-border-radius: 4px;  }
.bootstrap-frm select { background: #FFF  no-repeat right; appearance: none; -webkit-appearance: none; -moz-appearance: none; text-indent: 0.01px; text-overflow: ''; width:240px; height: 35px; line-height: 15px; }
.bootstrap-frm textarea {  float:left;  height: 100px; padding: 5px 0px 0px 5px; width:240px; }
.bootstrap-frm .button { background: #FFF; color: #333; border-radius: 4px; }
.bootstrap-frm .button:hover { color: #333; background-color: #EBEBEB; }
.bootstrap-frm label img { width:90px; height:30px; float:left; padding-left:5px; }

.bootstrap-frm2 {  max-width: 900px;}
.bootstrap-frm2 h1 { height:60px; line-height:60px; font-size:18px; border:none; padding:0; margin:0; color:#333;}
.bootstrap-frm2 label { width:48%; display: block; margin: 0px 0px 5px; padding-right:1.5%; float:left; }
.bootstrap-frm2 label span { float: left; width:150px; text-align: right; padding-right: 10px; margin-top: 10px;  font-weight: normal; font-size:16px; color:#333; }
.bootstrap-frm2 input[type="text"], 
.bootstrap-frm2 input[type="email"], 
.bootstrap-frm2 textarea, 
.bootstrap-frm2 select {width:250px; float:left; border: 1px solid #CCC; color: #888; height: 20px; line-height: 15px; margin-bottom: 16px; margin-right: 6px; margin-top: 2px; outline: 0 none; padding: 5px 0px 5px 5px;  border-radius: 4px; -webkit-border-radius: 4px; -moz-border-radius: 4px;  }
.bootstrap-frm2 select {width:250px;  background: #FFF no-repeat right; appearance: none; -webkit-appearance: none; -moz-appearance: none; text-indent: 0.01px; text-overflow: ''; height: 35px; line-height: 15px; }
.bootstrap-frm2 textarea {width:250px;  float:left;  height: 100px; padding: 5px 0px 0px 5px;  }
.bootstrap-frm2 .button { background: #FFF; color: #333; border-radius: 4px; }
.bootstrap-frm2 .button:hover { color: #333; background-color: #EBEBEB; }
.bootstrap-frm2 label img { width:90px; height:30px; float:left; padding-left:5px; }

</style>


// WEBPACK FOOTER //
// src/views/unit.vue